<template>
  <div class="user">
    <el-dialog
      :visible.sync="dialogFormVisible"
      @close="userClose(formRef)"
      :append-to-body="true"
    >
      <div slot="title"  class="dialog-footer">
        <div class="title">申请退款</div>
      </div>
      <div class="diaBox">
        <el-form :model="formRef" :rules="rules" ref="formRef"  >
          <el-form-item
            label="退款金额"
            :label-width="formLabelWidth"
            prop="refund_fee"
          >
            <el-input type="number" v-model="formRef.refund_fee"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('formRef')"
          >确 认</el-button>
      </div>
    </el-dialog>
    <!-- 面包屑导航 -->
    <el-card>
      <!-- 头 -->
       <el-row :gutter="20">
        <!-- <el-col :span="3">
          <el-input placeholder="请输入订单号" v-model="key">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchOrder"
            ></el-button>
          </el-input>
        </el-col> -->
            <el-col :span="9">
          <!-- <el-input placeholder="请输入内容" v-model="getInfo.info">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getListOrder"
            ></el-button>
          </el-input> -->
                  <!-- <span style="margin-right:10px;">按时间查询订单</span> -->
              <el-date-picker
      v-model="value1"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      @change="dateChange"
      value-format="yyyy-MM-dd mm:hh:ss"
      end-placeholder="结束日期">
    </el-date-picker>
        </el-col>
           <el-col :span="3">
          <el-tooltip
            v-if="orderFalag"
            class="item"
            effect="dark"
            content="打开提示音"
            placement="top-start"
          >
            <el-button type="primary" @click="openOrder"
              >打开提示音</el-button
            >
          </el-tooltip>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="关闭提示音"
            placement="top-start"
          >
            <el-button type="danger" @click="closeOrder"
              >关闭提示音</el-button
            >
          </el-tooltip>
          <!-- <div>
            <i class="el-icon-microphone" @click="play()" ></i>
            <i class="el-icon-video-pause" @click="paused()"></i> 
            <i class="el-icon-video-play" @click="goahead()" ></i>
          </div> -->
        </el-col>
        <el-col :span="12">
          <div class="border">
            <el-select @change="changeState(state)" v-model="state" placeholder="请选择">
    <el-option
      v-for="item in list"
      :key="item.state"
      :label="item.name"
      :value="item.state">
    </el-option>
  </el-select>
            <!-- <div
              @click="changeState(item)"
              v-for="item in list"
              :key="item.name"
              class="border-item"
              :class="[item.state == state ? 'active' : '']"
            >
              {{ item.name }}
            </div> -->
            <div class="border-item" style="margin-left:20px;color:white;background-color: rgb(64,158,255);"  @click="onPrint">
              导出销售统计表
            </div>
            <div class="border-item" style="color:white;background-color: rgb(64,158,255);"  @click="onPrint1">
              导出订单统计表
            </div>
          </div>
        </el-col>
       </el-row>
      <el-row :gutter="20">       
      </el-row>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column width="120px" prop="url" label="商品图片">
          <template slot-scope="scope">
            <div :class="[scope.row.sub_order_list.length>0?'image':'activeimage']">
              <div v-if="scope.row.sub_order_list.length>0">
              <img
                :src="scope.row.sub_order_list[0].c_img"
                alt=""
                width="100"
                v-if="scope.row.sub_order_list[0].c_img"
              />
                 </div>
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="add_time" width="160px" label="订单日期"></el-table-column>
        <el-table-column prop="user_info.nick_name" width="100px" label="客户名称"> </el-table-column>
        <el-table-column prop="desk" width="80px" label="桌号"> </el-table-column>
        <!-- <el-table-column prop="person" width="80px"  label="用餐人数"> </el-table-column> -->
        <el-table-column prop="desk" width="80px" label="就餐方式"> 
                  <template slot-scope="scope">
            <el-tag v-show="scope.row.takeaway == 1">堂食</el-tag>
            <el-tag v-show="scope.row.takeaway == 2">外带</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="order" width="130px" label="订单编号"> </el-table-column>
        <!-- <el-table-column prop="total_amount" label="订单总价"></el-table-column> -->
        <!-- <el-table-column prop="payment_time" width="180px" label="支付时间"></el-table-column> -->
                <el-table-column
          prop="payment_amount"
          label="实收金额"
          width="80px"
        ></el-table-column>
        <el-table-column
          prop="total_prices"
          label="订单金额"
          width="80px"
        ></el-table-column>
        
        <el-table-column prop="status" label="订单状态" width="100px">
          <template slot-scope="scope">
            <!-- 0待付款；1待发货；2已发货；3已完成；4已关闭；5无效订单 -->
            <!-- <el-tag v-show="scope.row.state == 0">待付款</el-tag> -->
            <el-tag v-show="scope.row.state == 0">订单关闭</el-tag>
            <el-tag v-show="scope.row.state == 1">待支付</el-tag>
            <el-tag v-show="scope.row.state == 2">支付成功</el-tag>
            <el-tag v-show="scope.row.state == -1"><div style="color:red;">售后订单</div></el-tag>
            <!-- <el-tag type="success" v-show="scope.row.state == 3"
              >已完成</el-tag
            >
            <el-tag v-show="scope.row.state == 4">已关闭</el-tag>
            <el-tag v-show="scope.row.state == 5">无效订单</el-tag> -->
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button
              type="success"
              size="mini"
              icon="el-icon-check"
              @click="conOpen(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              @click="refOpen(scope.row)"
            ></el-button> -->
            <el-button
              size="mini"
              icon="el-icon-search"
              @click="searchOpen(scope.row)"
            ></el-button>
            <el-button
              size="mini"
              icon="el-icon-printer"
              type="warning"
              @click="printOpen(scope.row)"
            ></el-button>
            <el-button
              size="mini"
              style="background-color: red;"
              @click="onRefund(scope.row)"
              v-if="scope.row.state==2"
            >
           <div style="color: white;">退</div>
          </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @current-change="pageChange"
        @size-change="sizeChange"
        :page-sizes="[7, 15, 20]"
        layout="total, sizes, prev, pager, next"
        :page-size="this.getInfo.page_num"
        background
        :total="exp.total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {PostOrderRefund , getList, getInfo, printAgain,PostOrderFlowList,PostOrderFlowListExport,PostOrderTransactionDetailsListExport } from "@/api/order.js";
import Speech from "speak-tts";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    var validateRefundFee= (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入金额'));
        }  else {
          callback();
        }
      };
    return {
      rules:{
        refund_fee:[{ validator: validateRefundFee, trigger: 'blur' }]
      },
       value1: [],
       key:'',//订单号
      speech: null,
      orderFalag:true,
      state:'',
      openState: false,
      //总页数
      exp: {
        count: Number,
        num: 0,
      },
      //总页数
      exp: {
        total: 0,
      },
      //当前页码
      getInfo: {
        //搜索框
        cat_id: 1,
        info: "",
        page: 1,
        page_num: 7,
      },
      //导航
      nav: [],
      //单选列表
      radiolist: [
        {
          id: 1,
          name: "一级",
        },
        {
          id: 2,
          name: "二级",
        },
      ],
      formRef:{
        form_id:'',
        refund_fee:''
      },
      //上级列表
      options: [],
      getNav: [],
      //即将删除的信息
      userdelinfo: {},
      // 添加信息表单
      form: {
        w_id: "",
        area: "",
        seat: "",
      },
      //表单名称长度
      formLabelWidth: "120px",
      //控制弹窗删除
      dialogVisible: false,
      //控制弹窗--新增修改
      dialogFormVisible: false,
      //搜索框
      inputSearch: "",
      //表格数据
      tableData: [],
      obligationTable: '',
      list: [

        { name: "已支付", state: 2 },
        { name: "未支付", state: 1 },
        { name: "全部订单", state: '' },
        { name: "售后订单", state: -1 },
      ],
      timer:null
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //确认退款
    submitForm(fromRef){
      this.$refs[fromRef].validate((valid) => {
          if (valid) {
            this.PostOrderRefund(this.formRef);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    //退款金额
    onRefund(row){
      this.dialogFormVisible=true;
      this.formRef.form_id=row.id;
      this.formRef.refund_fee=row.payment_amount;
           console.log(row)
    },
    //打印列表
    onPrint(){
      var datas = {
        page: 1,
        page_num: 7,
        state:this.state,
        start_date:this.value1?this.value1[0]:'',
        end_date:this.value1?this.value1[1]:''
      };
      this.PostOrderTransactionDetailsListExport(datas);
      //console.log(datas)
    },
    //订单统计表
    onPrint1(){
      var datas = {
        page: 1,
        page_num: 7,
        state:this.state,
        start_date:this.value1?this.value1[0]:'',
        end_date:this.value1?this.value1[1]:''
      };
      this.PostOrderFlowListExport(datas);
    },
    //订单号搜索
    searchOrder(){
      console.log(this.key,this.value1)
         var datas = {
        page: 1,
        page_num: 7,
        state:0,
        start_date:this.value1.length>0?'':this.value1[0],
        end_date:this.value1.length>0?'':this.value1[1],
        keyword:this.key
      };
   
      this.getListOrder(datas);
    },
    dateChange(){
        var datas = {
        page: 1,
        page_num: 7,
        state:this.state,
        start_date:this.value1?this.value1[0]:'',
        end_date:this.value1?this.value1[1]:''
      };
      
      this.getListOrder(datas);
         console.log(this.value1)
    },
    // 打印按钮
    async printOpen(row){
        console.log(row.id)
        const res = await printAgain({
            id:row.id
        })
        console.log(res)
        this.$message.success(res.data.message)
    },
        //打开订单提示音
    openOrder() {
      this.state=0;
      this.orderFalag = false;
      var datas = {
        page: 1,
        page_num: 7,
        state:0,
            start_date:this.value1?'':this.value1[0],
        end_date:this.value1?'':this.value1[1],
        keyword:this.key
      };
      this.getListOrderStatus(datas);
      this.timer = window.setInterval(() => {
        setTimeout(() => {
          this.getListOrderStatus({
        page: 1,
        page_num: 7,
        state:0,
            start_date:this.value1?'':this.value1[0],
        end_date:this.value1?'':this.value1[1],
        keyword:this.key
      });
        }, 0);
      }, 3000);
    },
    //关闭订单提示音
    closeOrder() {
      this.orderFalag = true;
      
      window.clearInterval(this.timer);
      this.timer=null;
    },
    changeState(state) {
      this.state = state;
      if(state){
            var data = {
        page: 1,
        page_num: this.getInfo.page_num,
        state:state,
        start_date:this.value1?this.value1[0]:'',
        end_date:this.value1?this.value1[1]:'',
        keyword:this.key
      };
      }else{
          var data = {
        page: 1,
        page_num: 20,
            start_date:this.value1?this.value1[0]:'',
        end_date:this.value1?this.value1[1]:'',
        keyword:this.key
      };
      }
  
      this.getListOrder(data);
    },
    //修改每页数量
    sizeChange(value) {
      console.log(value);
      this.getInfo.page_num = value;
      var datas = {
        page: this.getInfo.page,
        page_num: this.getInfo.page_num,
        state:this.state,
            start_date:this.value1.length>0?'':this.value1[0],
        end_date:this.value1.length>0?'':this.value1[1],
        keyword:this.key
      };
         this.getListOrder(datas);
    },
    //分页切换
    pageChange(value) {
       this.getInfo.page = value;
       var datas = {
        page:value,
        page_num: this.getInfo.page_num,
        state:this.state,
        start_date:this.value1?this.value1[0]:'',
        end_date:this.value1?this.value1[1]:'',
        keyword:this.key
      };
         this.getListOrder(datas);
    },
    //拒绝
    refOpen(row, form) {
      this.openState = false;
      this.dialogVisible = true;
      this.userdelinfo = row;
    },
    //同意
    conOpen(row, form) {
      this.openState = true;
      this.dialogVisible = true;
      this.userdelinfo = row;
    },
    //删除打开
    searchOpen(row, form) {
      this.dialogVisible = true;
      this.userdelinfo = row;
    },
    // 删除
    async setDel() {
      let info = await getDel({
        id: this.userdelinfo.id,
      });
      this.judge(info);
    },
    // 查看详情
    searchOpen(info) {
      this.$router.push({
        path: "/orderInfo",
        query: {
          keyword: info.number,
        },
      });
    },
    //搜索事件
    search(e) {
      console.log("搜索信息: " + e);
    },
    //添加事件--提交事件
    async setAdd(e) {
      let info = await getAdd(this.form);
      this.judge(info);
    },
    judge(info) {
      if (info.data.code == 0) {
        this.$message({
          message: info.data.message,
          type: "success",
        });
        this.dialogFormVisible = false;
        this.dialogVisible = false;
        this.getListOrder();
      } else {
        this.$message({
          showClose: true,
          message: info.data.message,
          type: "error",
        });
        return;
      }
    },
        SpeechInit() {
      this.speech = new Speech();
      this.speech.setLanguage("zh-CN");
      this.speech.init().then(() => {});
      console.log(1);
    },
    //播放按钮
    play() {
      this.speech
        .speak({
          text: "你有新的订单，请查收!",
          listeners: {
            //开始播放
            onstart: () => {
              console.log("Start utterance");
            },
            //判断播放是否完毕
            onend: () => {
              console.log("End utterance");
            },
            //恢复播放
            onresume: () => {
              console.log("Resume utterance");
            },
          },
        })
        .then(() => {
          console.log("读取成功");
        });
    },
    //暂停
    paused() {
      this.speech.pause();
    },
    //从暂停处继续播放
    goahead() {
      this.speech.resume();
    },
    //添加事件 退出弹窗
    userClose(e) {
      this.formRef = {
        form_id:'',
        refund_fee:''
      };
      console.log("close");
    },
    //目录接口
    // catalogue() {
    //   let info = await getListOrder(this.getInfo);
    //   this.tableData = info.data.data.data;
    //   this.exp.total = info.data.data.total;
    // },
     /*------------------------------网络请求函数----------------------------*/
     async PostOrderRefund(data){
          let res=await PostOrderRefund(data);
          if(res.data.code==1){
          this.$message({
            message:res.data.message,
            type:'success'
          })
          this.dialogFormVisible=false;
        }else{
          this.$message.error(res.data.message);
          this.dialogFormVisible=false;
        }
     },
     async PostOrderFlowListExport(data){
      let res=await PostOrderFlowListExport(data);
      console.log(res);
        if(res.data.code==1){
          this.$message({
            message:res.data.message,
            type:'success'
          })
            window.location.href=res.data.data.url     
        }
     },
     async PostOrderTransactionDetailsListExport(data){
      let res=await PostOrderTransactionDetailsListExport(data);
      console.log(res);
        if(res.data.code==1){
          this.$message({
            message:res.data.message,
            type:'success'
          })
            window.location.href=res.data.data.url     
        }
     },
    //获取订单信息
    async getListOrder(data) {
      let res = await PostOrderFlowList(data);
      console.log(res.data);
      if (res.data.code == 1) {
        //  console.log(res.data.data.data.length,this.tableData.length)
        // if(res.data.data.data.length>this.tableData.length){
        //     this.play();
        //    console.log("播放订单")
        // }
               if(res.data.data.data.length==0){
             this.$message({
          message: '没有该时间段数据',
          type: 'success'
        });
         this.tableData =[]
        return true;
        }
        this.tableData = res.data.data.data;
        this.exp.total = res.data.data.total;
      } else {
        this.$message.error(res.message);
      }
    },
     async getListOrderStatus(datas) {
      let res = await PostOrderFlowList(datas);
      console.log(res);

      if (res.data.code == 1) {
        //  console.log(res.data.data.data.length,this.tableData.length)
        // if(res.data.data.data.length>this.tableData.length){
        //     this.play();
        //    console.log("播放订单")
        // }
        console.log(res.data.data);
        if(res.data.data.length==0){
             this.$message({
          message: '没有该时间段数据',
          type: 'success'
        });
        return true;
        }
         
        if (res.data.data.total > this.obligationTable) {
          if (this.falag) {
            this.play();
            console.log("播放订单");
          }
        }
        this.falag = true;
        this.obligationTable = res.data.data.total;
        //  console.log(res.data.exp.num,this.obligationTable)
         var data={
       page: this.getInfo.page,
        page_num: this.getInfo.page_num,
        state: 0,
            start_date:this.value1.length>0?'':this.value1[0],
        end_date:this.value1.length>0?'':this.value1[1],
        keyword:this.key
    }
        this.getListOrder(data);
        // console.log(this.obligationTable);
      } else {
        this.$message.error(res.message);
      }
    },
    
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var data={
       page: this.getInfo.page,
        page_num: this.getInfo.page_num,
        state: 0,
    }
       this.getListOrder(data);
      this.SpeechInit();
  },
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
 
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
};
</script>

<style scoped >
.page {
  margin-top: 20px;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.set-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.set-page-left {
  color: #0000006d;
  font-size: 14px;
  font-weight: 400;
}
.border {
  display: flex;
}
.border-item {
  border: 1px solid #eee;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 6px;
  color: #666;
  margin-right: 5px;
}
.active {
  color: #909399 !important;
  background: #f4f4f5 !important;
}
.image {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  justify-items: center;
  align-items: center;
  /* background: #c0c4cc; */
  overflow: hidden;
}
.activeimage{ 
    width: 100px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  justify-items: center;
  align-items: center;
  background: #c0c4cc;
  overflow: hidden;
}
 .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .el-form--inline .el-form-item__label{
     width: 90px!important;
    color: #99a9bf!important;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .page {
  margin-top: 20px;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.set-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.set-page-left {
  color: #0000006d;
  font-size: 14px;
  font-weight: 400;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.diaBox {
  display: flex;
  justify-content: center;
}
</style>